module.exports = __webpack_public_path__ + "static/media/Modals.9d50ecd0.scss";


//////////////////
// WEBPACK FOOTER
// ./src/modules/modals/Modals.scss
// module id = 899
// module chunks = 0